import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleAutocompleteDirective } from 'app/directives/google-autocomplete/google-autocomplete.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [GoogleAutocompleteDirective],
    exports: [GoogleAutocompleteDirective],
})
export class GoogleAutocompleteModule
{
}
